import React, { useState } from 'react'
import { Chevron } from 'app/assets/icons'
import { H6, SmallText } from 'app/common/typography'
import { Collapse } from 'react-collapse'
import { FormattedMessage } from 'react-intl'
import { colors } from 'shared/assets/styles'
import styled from 'styled-components'

const { text, grey } = colors

type Props = {
    legalMentions: string
}

const BlazonLegalNotice = (props: Props) => {
    const { legalMentions } = props
    const [isOpen, setIsOpen] = useState(false)

    return (
        <Root>
            <CollapseTitle onClick={() => setIsOpen(state => !state)}>
                <H6>
                    <FormattedMessage id="legal.notice" />
                </H6>
                <Chevron color={text} direction={isOpen ? 'up' : 'down'} />
            </CollapseTitle>
            <Collapse isOpened={isOpen}>
                <Description>{legalMentions}</Description>
            </Collapse>
        </Root>
    )
}

const Root = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;

    .ReactCollapse--collapse {
        transition: height 500ms;
    }
`

const CollapseTitle = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding-right: 8px;
    cursor: pointer;
`

const Description = styled(SmallText)`
    white-space: pre-line;
    color: ${grey};
`

export default BlazonLegalNotice
